// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Term = (function () {
    function Term(value0) {
        this.value0 = value0;
    };
    Term.create = function (value0) {
        return new Term(value0);
    };
    return Term;
})();
var Closure = (function () {
    function Closure(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Closure.create = function (value0) {
        return function (value1) {
            return new Closure(value0, value1);
        };
    };
    return Closure;
})();
var TermEnvironment = function (x) {
    return x;
};
var semigroupTermEnvironment = function (dictSemigroup) {
    return Data_Map_Internal.semigroupMap(Data_Ord.ordString);
};
var newtypeTermEnvironment = new Data_Newtype.Newtype(function (n) {
    return n;
}, TermEnvironment);
var monoidTermEnvironment = Data_Map_Internal.monoidMap(Data_Ord.ordString);
var lookup = function (key) {
    var $39 = Data_Maybe.fromMaybe(new Term(Lunarbox_Data_Dataflow_Runtime.Null.value));
    var $40 = Data_Map_Internal.lookup(Data_Ord.ordString)(key);
    var $41 = Data_Newtype.unwrap(newtypeTermEnvironment);
    return function ($42) {
        return $39($40($41($42)));
    };
};
var insert = function (key) {
    return function (value) {
        return function (v) {
            return TermEnvironment(Data_Map_Internal.insert(Data_Ord.ordString)(key)(value)(v));
        };
    };
};
var eqTermEnvironment = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Internal.eqMap(Data_Eq.eqString)(eqTerm(dictEq)))(x)(y);
        };
    });
};
var eqTerm = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Term && y instanceof Term) {
                return Data_Eq.eq(Lunarbox_Data_Dataflow_Runtime.eqRuntimeValue)(x.value0)(y.value0);
            };
            if (x instanceof Closure && y instanceof Closure) {
                return Data_Eq.eq(eqTermEnvironment(dictEq))(x.value0)(y.value0) && Data_Eq.eq(Lunarbox_Data_Dataflow_Expression.eqExpression(dictEq))(x.value1)(y.value1);
            };
            return false;
        };
    });
};
var encodeJsonTerm = function (dictEncodeJson) {
    return new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
        if (v instanceof Term) {
            return Data_Argonaut_Encode_Class.encodeJson(Lunarbox_Data_Dataflow_Runtime.encodeJsonRuntimeValue)(v.value0);
        };
        return Data_Argonaut_Encode_Class.encodeJson(Lunarbox_Data_Dataflow_Runtime.encodeJsonRuntimeValue)(Lunarbox_Data_Dataflow_Runtime.Null.value);
    });
};
var encodeJsonTermEnvironment = function (dictEncodeJson) {
    return Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordString)(Data_Argonaut_Encode_Class.encodeJsonJString)(encodeJsonTerm(dictEncodeJson));
};
var defTerm = new Data_Default.Default(new Term(Lunarbox_Data_Dataflow_Runtime.Null.value));
var decodeJsonTerm = function (dictDecodeJson) {
    return new Data_Argonaut_Decode_Class.DecodeJson((function () {
        var $43 = Data_Functor.map(Data_Either.functorEither)(Term.create);
        var $44 = Data_Argonaut_Decode_Class.decodeJson(Lunarbox_Data_Dataflow_Runtime.decodeJsonRuntimeValue);
        return function ($45) {
            return $43($44($45));
        };
    })());
};
var decodeJsonTermEnvironment = function (dictDecodeJson) {
    return Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordString)(Data_Argonaut_Decode_Class.decodeJsonString)(decodeJsonTerm(dictDecodeJson));
};
module.exports = {
    TermEnvironment: TermEnvironment,
    Term: Term,
    Closure: Closure,
    lookup: lookup,
    insert: insert,
    eqTerm: eqTerm,
    defTerm: defTerm,
    encodeJsonTerm: encodeJsonTerm,
    decodeJsonTerm: decodeJsonTerm,
    eqTermEnvironment: eqTermEnvironment,
    newtypeTermEnvironment: newtypeTermEnvironment,
    semigroupTermEnvironment: semigroupTermEnvironment,
    monoidTermEnvironment: monoidTermEnvironment,
    encodeJsonTermEnvironment: encodeJsonTermEnvironment,
    decodeJsonTermEnvironment: decodeJsonTermEnvironment
};
